import axios, { API_BASE_URL } from './axiosConfig';

// Obtener las notificaciones del usuario
export const fetchUserNotifications = async (userId: number) => {
  console.log(API_BASE_URL);

  try {
    const response = await axios.get(`${API_BASE_URL}/notifications/${userId}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('access_token')}`,
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Error fetching user notifications');
    }
  } catch (error) {
    console.error('Error fetching user notifications:', error);
    throw error;
  }
};

export const fetchAdminNotifications = async () => {
  console.log(API_BASE_URL);

  try {
    const response = await axios.get(`${API_BASE_URL}/notifications`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('access_token')}`,
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Error fetching admin notifications');
    }
  } catch (error) {
    console.error('Error fetching admin notifications:', error);
    throw error;
  }
};